import { applyMiddleware, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'

import { locales, defaultLocale } from 'i18n';

import rootReducer from 'logic/reducers'
import rootSaga from 'logic/sagas'

const preparedInitialState = {
  intl: {
    locale: defaultLocale,
    messages: locales[defaultLocale],
  }
}

const bindMiddleware = middleware => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension')
    return composeWithDevTools(applyMiddleware(...middleware))
  }
  return applyMiddleware(...middleware)
}

// const queryMiddleware = store => next => action => {
//   console.log('middle', store.getState())
//   action.locationQuery = store.getState().router.query
//   next(action)
// }

function configureStore(initialState = preparedInitialState) {
  const sagaMiddleware = createSagaMiddleware()
  const store = createStore(
    rootReducer,
    initialState,
    bindMiddleware([sagaMiddleware])
  )

  store.sagaTask = sagaMiddleware.run(rootSaga)

  return store
}

export default configureStore
